import { globalState } from '@codeleap/store'
import { onMount } from 'nanostores'

function isNotificationsAvailable() {
  const available = 'Notification' in window

  return available
}

type PermissionStatus = NotificationPermission | 'unavailable'

const STORAGE_KEY = 'notification-permission-enabled'

const state = globalState<{ status: PermissionStatus; enabled: boolean }>({
  status: 'unavailable',
  enabled: typeof window !== 'undefined'
    ? localStorage.getItem(STORAGE_KEY) !== 'false'
    : true,
})

function refreshStatus() {
  if (!isNotificationsAvailable()) return

  state.set({
    status: Notification.permission,
  })
}

onMount(state, () => {
  refreshStatus()
})

const getStatus = () => {
  return state.get().status ?? ''
}

const isGranted = () => {
  return getStatus() === 'granted'
}

export const isDenied = () => {
  return getStatus() === 'denied'
}

const shouldRequest = () => {
  if (!isNotificationsAvailable()) return false
  return !isGranted()
}

export async function request() {
  if (!isNotificationsAvailable()) return
  try {

    const newStatus = await Notification.requestPermission()

    state.set({
      status: newStatus,
    })

  } catch (e) {
    console.error(e)
  }
}

export async function requestIfNeeded() {
  if (shouldRequest()) {
    return await request()
  }
}

export function setEnabled(value: boolean) {
  state.set({
    ...state.get(),
    enabled: value,
  })

  if (typeof window !== 'undefined') {
    localStorage.setItem(STORAGE_KEY, String(value))
  }
}

export function getEnabled() {
  return state.get().enabled
}

export function useEnabled() {
  return state.use(s => s.enabled)
}

export function useStatus() {
  const status = state.use(s => s.status)

  return {
    granted: isGranted(),
    available: status != 'unavailable',
  }
}
